class CartCount extends HTMLElement {
  constructor() {
    super();

    this.iconElement = this.closest(this.selectors.icon);
  }

  selectors = {
    icon: "[data-cart-bubble]"
  };

  excludedSKUs = ["NARVARDELIVERYPROTECTION"];

  modifiers = {
    bubble: {
      hidden: "header__cart-icon-count--hidden"
    },
    icon: {
      full: "header__cart-icon--full"
    }
  };

  connectedCallback() {
    document.addEventListener("cart:change", this.onCartChange.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("cart:change", this.onCartChange.bind(this));
  }

  onCartChange(event) {
    const cart = event?.detail?.cart;
    const itemCount = cart?.items ? this.getFilteredCount(cart.items) : undefined;
    this.renderCartCount(itemCount);
  }

  getFilteredCount(items = []) {
    return items
      .filter(item => !this.excludedSKUs.includes(item.sku))
      .reduce((total, item) => total + item.quantity, 0);
  }

  async renderCartCount(itemCount) {
    if (!itemCount) {
      const cart = await this.getCartData();
      itemCount = cart?.items ? this.getFilteredCount(cart.items) : 0;
    }

    this.innerText = itemCount > 99 ? "99+" : itemCount;

    if (this.iconElement) {
      this.iconElement.classList.toggle(this.modifiers.icon.full, !!itemCount);
    }

    this.classList.toggle(this.modifiers.bubble.hidden, !itemCount);
  }

  async getCartData() {
    return await (await fetch(`${Shopify.routes.root}cart.js`)).json();
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
